export const EXECUTIVE = 1
export const FUNDING = 2
export const TRAILER_LEASING = 3
export const TRUCK_RENTAL = 4
export const TRUCK_SALES = 5
export const FINANCE = 6
export const INSURANCE = 7
export const CPS = 8
export const LOGISTICS = 9
export const SMARTBOARD = 10
export const PLANET_DIGITAL_MEDIA = 12
export const UNITED = 13

export const MIGRATED_DIVISIONS_TO_NEW_CRM = [
  SMARTBOARD,
  FUNDING,
  PLANET_DIGITAL_MEDIA,
  TRAILER_LEASING,
  UNITED,
  EXECUTIVE,
  CPS,
  LOGISTICS,
  FINANCE,
  INSURANCE,
  TRUCK_SALES,
]
